// src/pages/Results.js
import React, { useMemo, useState, useEffect } from "react";
import "../styles/results.css"; // CSS de la page Actus
/* Sponsors */
import spBelgium     from "../assets/images/img30.webp";
import spAdepsFWB    from "../assets/images/sponsors-adeps-fwb.jpg";
import spJudoWB      from "../assets/images/sponsors-jwb.png";
import spKoekelberg  from "../assets/images/sponsors-koekelberg.png";
/* --- Liens + images (public/images/...) --- */
const googleWriteReview =
  "https://www.google.com/search?q=Wolves+Judo+Bruxelles+Reviews";
export const SPONSORS = [
  spBelgium,
  spAdepsFWB,
  spJudoWB,
  spKoekelberg,
];


/* --- Données actus --- */
// Images servies depuis public/images/*  -> src="/images/xxx"
const NEWS = [
  {
    id: "2025-09-22-brabant-open-yasmine",
    date: "2025-09-22",
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "Brabant Open 2025 — Yasmine Miri 3e place",
    excerpt:
      "Une superbe médaille de bronze au Brabant Open 2025 pour Yasmine ! Engagement et combativité exemplaires.",
    image: "/images/imgyasminebrabant.jpg",
  },
  {
    id: "2025-04-20-bayer-cup-yasmine",
    date: "2025-04-20", // corrige si besoin
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "Bayer Cup 2025 — 3e place",
    excerpt: "Une superbe médaille de bronze pour Yasmine !!",
    image: "/images/imgyasminebayern.jpg",
  },
  {
    id: "2025-09-21-daniel-ceinture-noire",
    date: "2025-09-21",
    club: "Wolves Bruxelles",
    category: "Club",
    title: "Daniel El Moudni — Ceinture noire !",
    excerpt:
      "Félicitations à Daniel pour l’obtention de la ceinture noire. Un aboutissement d’années d’investissement et de passion.",
    image: "/images/imgdanielnoire.jpg",
  },
  {
    id: "2025-06-27-maroc-moubarak",
    date: "2025-06-27",
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "Moubarak Boulaich — Champion du Maroc 2025",
    excerpt:
      "Titre national pour Moubarak ! Une victoire qui couronne un gros travail et une saison exemplaire.",
    image: "/images/img6.jpg",
  },
  {
    id: "2025-06-15-dudelange-emilian",
    date: "2025-06-15",
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "LaLux Judo Open Dudelange 2025 — Emilian Kyslenko",
    excerpt:
      "Belle perf d’Emilian au LaLux Open de Dudelange. Engagement, rythme et belles séquences enchaînées.",
    image: "/images/img31.jpg",
  },
  {
    id: "2025-06-15-dudelange-yasmine",
    date: "2025-06-15",
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "LaLux Judo Open Dudelange 2025 — Yasmine Miri",
    excerpt:
      "Yasmine enchaîne un tournoi solide à Dudelange. De l’initiative et un bel esprit de combat.",
    image: "/images/img32.jpg",
  },
  {
    id: "2025-06-15-dudelange-rudy",
    date: "2025-06-15",
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "LaLux Judo Open Dudelange 2025 — Rudy Mandiangu",
    excerpt: "Belle présence et bonnes sensations. On continue !",
    image: "/images/img33.jpg",
  },
  {
    id: "2025-02-16-belgique-u18-emilian",
    date: "2025-02-16",
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "Championnat de Belgique U18 2025 — Emilian Kyslenko",
    excerpt: "Un cap franchi. Expérience précieuse au niveau national.",
    image: "/images/img34.jpg",
  },
  {
    id: "2024-11-30-interclubs-d4",
    date: "2024-11-30",
    club: "Wolves Bruxelles",
    category: "Résultats",
    title: "Interclubs D4 2024",
    excerpt: "Une belle journée d’équipe et de cohésion.",
    image: "/images/img2.png",
  },
  {
    id: "2025-daniel-arbitre",
    date: "2025-01-01", // date complète pour l’affichage
    club: "Wolves Bruxelles",
    category: "Club",
    title: "Daniel El Moudni diplômé arbitre",
    excerpt:
      "Félicitations à Daniel pour l’obtention du diplôme d’arbitre. Une étape importante pour le club.",
    image: "/images/img35.jpg",
  },
];

/* --- Footer réutilisable pour cette page --- */
function PageFooter() {
  return (
    <footer className="footer">
      <section id="avis" className="section">
        <div className="container">
          <div className="reviews-head">
            <h2>Avis Google</h2>
            <p>Ton avis nous aide à grandir. Merci pour ton retour !</p>
          </div>

          <div className="reviews-cta">
            <a
              className="btn-primary btn-review"
              href={googleWriteReview}
              target="_blank"
              rel="noreferrer"
            >
              Laisser un avis sur Google
            </a>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="sponsor-strip" aria-label="Sponsors et partenaires">
          <span className="sponsor-label">Avec le soutien de</span>
          <ul className="sponsor-logos">
            {SPONSORS.map((s, i) => (
              <li key={i}>
                <img src={s.src} alt={s.alt} loading="lazy" />
              </li>
            ))}
          </ul>
        </div>

        <div className="foot-bottom">
          © {new Date().getFullYear()} <b>Wolves Bruxelles!</b>
        </div>
      </div>
    </footer>
  );
}

export default function Results() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("toutes");
  const [active, setActive] = useState(null); // lightbox

  // tri + filtres
  const items = useMemo(() => {
    const base = [...NEWS].sort((a, b) => new Date(b.date) - new Date(a.date));
    return base.filter((p) => {
      const okCat = cat === "toutes" ? true : p.category === cat;
      const okQ =
        q.trim() === ""
          ? true
          : (p.title + " " + p.excerpt + " " + p.category)
              .toLowerCase()
              .includes(q.toLowerCase());
      return okCat && okQ;
    });
  }, [q, cat]);

  // fermer la lightbox avec Échap
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setActive(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <>
      <div className="news-page">
        {/* Topbar: bouton retour en haut */}
        <div className="news-topbar">
          <a className="btn-back-home" href="/">← Retour accueil</a>
        </div>

        <header className="news-hero">
          <div className="wrap">
            <h1>Actus du club</h1>
            <p className="sub">Résultats, annonces, événements & coulisses.</p>

            <div className="tools">
              <div className="tabs">
                <button
                  className={cat === "toutes" ? "tab active" : "tab"}
                  onClick={() => setCat("toutes")}
                >
                  toutes
                </button>
                <button
                  className={cat === "Résultats" ? "tab active" : "tab"}
                  onClick={() => setCat("Résultats")}
                >
                  Résultats
                </button>
                <button
                  className={cat === "Club" ? "tab active" : "tab"}
                  onClick={() => setCat("Club")}
                >
                  Club
                </button>
              </div>

              <input
                className="search"
                placeholder="Rechercher une actu…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />
            </div>
          </div>
        </header>

        <main className="news-wrap">
          <ul className="grid">
            {items.map((post) => (
              <li
                key={post.id}
                className="card"
                onClick={() => setActive(post)}
              >
                <div className="thumb">
                  <img src={post.image} alt={post.title} loading="lazy" />
                </div>

                <div className="meta">
                  <span className="cat">{post.category}</span>
                  <time dateTime={post.date}>
                    {new Date(post.date).toLocaleDateString("fr-FR", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </time>
                </div>

                <h3 className="title">{post.title}</h3>
                <p className="excerpt">{post.excerpt}</p>
              </li>
            ))}
          </ul>
        </main>

        {/* Lightbox plein écran */}
        {active && (
          <div className="news-lightbox" onClick={() => setActive(null)}>
            <article
              className="news-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close"
                aria-label="Fermer"
                onClick={() => setActive(null)}
              >
                ×
              </button>

              <div className="modal-media">
                <img src={active.image} alt={active.title} />
              </div>

              <div className="modal-body">
                <span className="cat">{active.category}</span>
                <h2>{active.title}</h2>
                <p className="when">
                  {new Date(active.date).toLocaleDateString("fr-FR", {
                    weekday: "short",
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </p>
                <p className="text">{active.excerpt}</p>
              </div>
            </article>
          </div>
        )}
      </div>

      {/* Footer placé sous la page Actus */}
      <PageFooter />
    </>
  );
}
